require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-kevin-ryan.json") })
        }
      }, "path---articles-tags-kevin-ryan");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-kevin-ryan!./.cache/json/articles-tags-kevin-ryan.json
// module id = 1871
// module chunks = 231608221292675